/* src/app/components/shop/main-carousel/main-carousel.component.scss */
.container1 {
  width: 100% !important;
  margin: 0 auto !important;
  padding: 0 !important;
  background-color: rgba(0, 0, 0, 0.3) !important;
}
.swiper_h1 {
  margin: 0 auto !important;
  max-width: fit-content !important;
  color: rgb(255, 255, 255) !important;
}
.swiper_h3 {
  margin: 0 auto !important;
  max-width: fit-content !important;
  color: rgb(255, 255, 255) !important;
  margin-bottom: 30px !important;
}
/*# sourceMappingURL=main-carousel.component.css.map */
